export enum INSTALLMENT_STATUS {
  PENDING = 'PENDING',
  PAID = 'PAID',
  CANCELED = 'CANCELED',
  DIFFER = 'DIFFER',
  ERROR = 'ERROR',
  RESTRUCTURED = 'RESTRUCTURED',
  PRE_PAID_USER = 'PRE_PAID_USER',
  PRE_PAID_DISMISSAL = 'PRE_PAID_DISMISSAL',
}

export enum INSTALLMENT_FIELDS {
  STATUS = 'STATUS',
}
